import React from 'react';
import diagram from '../../assets/flow-diagram-1.jpg';

function FlowDiagram1() {
    return (
        <>
            <div className="flex flex-col justify-between py-4 px-8 mb-2 print-page-break">
                <div className="flex justify-end">
                    <div className="max-w-[250px] text-right">
                        <p>COMSAR/Circ.25</p>
                        <p>ANNEX</p>
                        <p>Page 3</p>
                    </div>
                </div>
                <h3 className="uppercase font-medium text-center text-sm">
                    Flow Diagram 1
                </h3>
                <img
                    src={diagram}
                    className="h-[400px]"
                    height={'400px'}
                    alt="Flow Diagram 1"
                />

                <div>
                    <h2 className="text-sm font-bold text-gray-800 mb-4">
                        REMARKS:
                    </h2>

                    <div className=" text-gray-700">
                        <div className="pl-4">
                            <div className="flex gap-x-2 ">
                                <div className=" w-[120px]">
                                    <strong>Note 1:</strong>
                                </div>
                                <span>
                                    Appropriate or relevant RCC or Coast Station
                                    shall be informed accordingly. If further
                                    DSC alerts are received from the same source
                                    and the ship in distress is beyond doubt in
                                    the vicinity, a DSC acknowledgement may,
                                    after consultation with an RCC or Coast
                                    Station, be sent to terminate the call.
                                </span>
                            </div>
                        </div>
                        <div className="pl-4">
                            <div className="flex gap-x-2 ">
                                <div className="w-[60px]">
                                    <strong>Note 2:</strong>
                                </div>
                                <span>
                                    In no case is a ship permitted to transmit a
                                    DSC distress relay call on receipt of a DSC
                                    distress alert on either VHF channel 70 or
                                    MF channel 218.75 kHz.
                                </span>
                            </div>
                        </div>

                        {/* Legend */}
                        <div className=" pt-2 mt-2">
                            <p className="text-sm text-gray-600 font-semibold text-center flex justify-center items-center gap-x-8">
                                <span>CS = Coast Station</span>
                                <span>RCC = Rescue Co-ordination Center</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default FlowDiagram1;
